export const BUTTONS = {
  KNOW_MORE: "تعرف علي وفي اكثر",
  TERMS_AND_CONDITIONS: "الشروط و الاحكام",
};
